import React, { useState, useEffect, useContext, Suspense } from "react";
import { ReactReduxContext } from "react-redux";
import { useParams, useHistory, Link } from "react-router-dom";
import { Redirect } from "react-router";
import { connect, useDispatch } from "react-redux";
import { COVERLETTER_BUILD, COVERLETTER_CHOOSE_TEMPLATE, COVERLETTER_EXPERIENCE, CREATE_RESUME, HOME_URL, TEMPLATE_IDS} from '../../constants/constants';
// import { updateTemplate } from "../services/actions/actions";
// import PageLoader from "./common/PageLoader";
// import Resumes from "./resumetemplates/Resumes";
import '../../assets/scss/app/cover-letter-screens/build-coverletter.scss';
import LeftBackGroundImage from '../../assets/images/home-animation.svg'
// import CoverImage from '../../assets/images/build-coverletter.svg'
import PageLoader from "../common/PageLoader";

const LandingPage = (props) => {

  const [redirectTo, setRedirectTo] = useState(false);
  const queryParameters = new URLSearchParams(window.location.search)
  const id = queryParameters.get("_tpl")
  const tpl= TEMPLATE_IDS[id]?.tpl ?? 'template-eleven'
  const color= TEMPLATE_IDS[id]?.color ?? 'color-variant-one'
  const customColor =  queryParameters.get("color") ? `#${queryParameters.get("color")}` : ''
//     const [redirect2, setRedirect2] = useState(null);

//     useEffect(() => {
//         setRedirect2(COVERLETTER_FINALIZE)
//     });

if (redirectTo) { 
  history.pushState(null, location.pathname)
  return <Redirect to={redirectTo} /> }

  return (
    <>
    <div className={`build-resume-page`}>
      <div className={`build-resume-page-left`}>
        <div className={`left-content`}>
          <LeftBackGroundImage />
          <div className={`build-resume-page-left-resume`}>
            <div className="resume-content-area">
              <img src="../../assets/images/build-coverletter.svg" alt="cover-image"/>
            </div>
          </div>
          <div className={`build-resume-page-left-bottom-cta`} onClick={() => {
                localStorage.setItem('cl_color', color);
                localStorage.setItem('cl_tpl', tpl);
                localStorage.setItem('cl_custom_color', customColor);
                localStorage.setItem('cl_builder', 'yes');  
                setRedirectTo(COVERLETTER_CHOOSE_TEMPLATE)
                ga4Track('app_build_coverletter_change_template', 'RT App', 'Build CoverLetter: Change Template')
            }}>
            <span  >
              Change Template
            </span>
          </div>
        </div> 
      </div>
      <div className="build-resume-page-right">
        <div className={`build-resume-page-right-heading`}>
          <h1>Let's build your perfect <span className={`not-black`}>cover letter</span>!</h1>
        </div>
        <div className={`build-resume-page-right-bullet-points`}>
          <ul>
            <li>
              <span className={`slno selected`}></span>
              <span className={`text`}>Step one, done! We'll use the template you selected.</span>
            </li>
            <li>
              <span className={`slno`}>2</span>
              <span className={`text`}>Next, you'll answer simple questions to build your cover letter.</span>
            </li>
            <li>
              <span className={`slno`}>3</span>
              <span className={`text`}>Finally, download your cover letter to get an interview!</span>
            </li>
          </ul>
        </div>
        <div className={`cta build-resume-page-right-bottom-cta`}>
          <button 
            className={`blue`} 
            onClick={() => {
              localStorage.setItem('cl_color', color);
              localStorage.setItem('cl_tpl', tpl);
              localStorage.setItem('cl_custom_color', customColor);
              localStorage.setItem('cl_builder', 'yes');  
              setRedirectTo(COVERLETTER_EXPERIENCE)
              ga4Track('app_build_resume_create_coverletter', 'RT App', 'Build Coverletter: Create Coverletter')
            }}>
            Create My Cover Letter
          </button>  
        </div>
        <div className="build-resume-page-right-bottom-notice"><small>By continuing, you agree to our <a href={`${HOME_URL}/terms-and-conditions/`} target="_blank">Terms of Service</a> and <a href={`${HOME_URL}/privacy-policy/`}  target="_blank">Privacy Policy.</a></small></div>
      </div>
    </div>
    </>
  );
};

export default LandingPage;
